import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { NZ_CONFIG, NzConfig } from 'ng-zorro-antd/core/config';
import { en_US, NZ_I18N } from 'ng-zorro-antd/i18n';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';

const ngZorroConfig: NzConfig = {
	message: { nzTop: 95, nzDuration: 3000 },
};

@NgModule({
	imports: [BrowserModule, CoreModule, AppRoutingModule],
	declarations: [AppComponent],
	providers: [
		{ provide: NZ_I18N, useValue: en_US },
		{ provide: NZ_CONFIG, useValue: ngZorroConfig },
	],
	bootstrap: [AppComponent],
})
export class AppModule {}
